import { ContactsApiProvider } from './contactsapi.services';

export const postHistoryEvent = (contactId, userId, opportunityId = null, message = null, customHistoryEvent = null) => {
  let historyEvent = {
    details: message,
    type: 'Lead',
    action: '2',
    initiatorType: '1', // USER
    initiatorRefId: userId,
    opportunityId: opportunityId
  };

  if (customHistoryEvent) {
    historyEvent = customHistoryEvent;
  }

  return ContactsApiProvider.post(`/contacts/${contactId}/historyevents`, historyEvent);
};
